// Styles
import './styles.scss';

// Core
import React, { Component } from 'react';
import { $stateParams } from '../../router';
import RSVP_CONSTS from '../../constants';
import { connect } from 'react-redux';

// Components
import { 
	GECKO_CONSTS, 
	GeckoBtn,
	GeckoToastService,
	GeckoDialogService,
	GeckoModalService,
	GeckoIcon,
    GeckoFields
} from '@geckolabs/gecko-react-ui';

// Services
import RsvpService from '../../services/RsvpService';
import RefreshData from '../../services/RefreshData';
import SelfCheckinRefreshInterval from '../../services/SelfCheckinRefreshInterval';
import SessionIsClosed from '../../services/SessionIsClosed';
import Utils from '../../services/utils/utils';
import EngageRequest from '../../services/EngageRequest';
import GeckoStore from '../../services/GeckoStore';
import DateUtils from '../../services/DateUtils';
import { __, STR_KEY } from '../../services/Translate';
import StatusControl from '../profile/StatusControl';
import moment from 'moment';
import {
	SessionClosedAlert,
	Description,
	Tags,
	HostsWrapper,
	BackButton,
	DeliveryMethod,
	Loader,
	TitleCard,
	NoTimesAvailable,
	Header
} from './Components';

import {
	WebinarUrl,
	WebinarDescription,
	openWebinarUrl
} from './Components/Webinar';

import {
	Location,
	mapsSelector,
	getLocationTitle,
	getLocationAddress
} from './Components/Location';

const checkFullAndHasWaitlisting = (entity) => entity.full && (entity.auto_waitlist && !entity.full_waitlist);
const closeModal = () => new GeckoModalService().close();
const getAttendances = () => GeckoStore.redux.get('attendances');

/**
 * Make a title for a session time by combining the start time and end time
 * 
 * @param object $time - the session time
 *
 * @return ?string
 */
const getSessionTimeTitle = (time) => {
	if (time && time.start_datetime && time.end_datetime) {
		const start = moment(time.start_datetime).format('ddd D MMM ' + DateUtils.timeFormat);
		const end = moment(time.end_datetime).format(DateUtils.timeFormat);
		
		return start + ' - ' + end;
	}

	return null;
}

const isSessionClosed = (session={}, cb) => {
	const sessionId    = session.id;

	return SessionIsClosed(sessionId).then(isClosed => {
		if (!isClosed) return Promise.resolve();

		return Promise.reject().finally(() => {
			new GeckoToastService().error(__(STR_KEY.PROFILE_SESSION_ALERT_CLOSED));
			
			if (typeof cb === 'function') cb();
		});
	});
}

const getData = (sessionId) => {
	const accountUuid = $stateParams.account_uuid;
	const contactUuid = $stateParams.contact_uuid;
	const eventId     = $stateParams.event_id;

	return Promise.all([
		EngageRequest.get(`/rsvp/${accountUuid}/${contactUuid}/${eventId}`).then(data => data.location),
		EngageRequest.get(`/rsvp/${accountUuid}/${contactUuid}/${eventId}/session/${sessionId}`)
	]).then(([topLevelEventLocation, data]) => ({
		topLevelEventLocation: topLevelEventLocation.length ? topLevelEventLocation[0] : null,
		session: data.session,
		times: data.times,
		hosts: data.hosts,
		location: data.location.length ? data.location[0] : null
	}));
}

export class SessionSingle extends Component {

	state = {
		loading: true,
		topLevelEvent: null,
		session: null,
		times: [],
		bookedSessionTimeId: null,
		selectedSessionTimeId: null,
		attendances: [],
		hosts: [],
		location: null,
		topLevelEventLocation: null,
		disableTimeButtons: false,
	}

	componentDidMount()
	{
		this.refreshModalData();

		// Force focus, you cant escape when nothing is focussed.
		RsvpService.setFocusInside();
	}

	refreshModalData() {
		const attendances = getAttendances();
		const attendances_by_id = attendances.reduce(function (accumulator, currentValue) {
    		return Object.assign(accumulator, {[currentValue.event_id]: currentValue});
		}, {});

		const sessionId = this.props.id;
		return getData(sessionId).then(data => {
			this.setState({
				attendances: attendances_by_id,
				topLevelEventLocation: data.topLevelEventLocation,
				session: data.session,
				times: data.times,
				hosts: data.hosts,
				location: data.location,
				topLevelEvent: this.props.event
			}, () => {
				this.setState({
					loading: false,
					bookedSessionTimeId: (this.getBookedTime() || {}).id
				})
			});
		});
	}


	/* ==========================
	
		Helpers

	========================== */

	composeUpdateCheckin(going = false) {

		const attendance = this.attendanceExcludingStatus();
            		
        let session_time_being_attended = this.state.times.find((time, key) => {
			return time.id === attendance.event_id;
		});

        const eventId = session_time_being_attended.id || this.props.id;

		// Navigate to stream page (when video_uuid is set on event)
	    if (RsvpService.isOnline(this.state.session) && session_time_being_attended.video_uuid) {
	    	closeModal();
	    	return RsvpService.goToStreamPage(eventId);
	    } else {
        	try {
                const attend = (going ? 'yes' : 'no');

                return this.executeUpdateCheckin(eventId).then(() => {
            		new GeckoToastService().success(__(STR_KEY.MODAL_SESSION_TOAST_CHECKED_IN));
                	openWebinarUrl(this.state.session, this.getBookedTime());
            	}).catch(err => new GeckoToastService().error(err));
            }
            catch(err) {
            	console.log(err);
            }
	    }
    }

	composeUpdateAttendance(going = false) {

		let message, params;

		if (going) {
			message = __(STR_KEY.MODAL_SESSION_ALERT_ACCEPT);
			params = {
				size: 'md',
				btns: {
					confirm: {label: __(STR_KEY.MODAL_SESSION_BTN_YES)},
					decline: {label: __(STR_KEY.MODAL_SESSION_BTN_NO)}
				}
			};
		} else {
			message = __(STR_KEY.MODAL_CANCEL_CONTENT)
			params = {
				size: 'md',
				btns: {
					confirm: {label: __(STR_KEY.MODAL_CANCEL_BTN_YES), type: 'danger'},
					decline: {label: __(STR_KEY.MODAL_CANCEL_BTN_NO)}
				}
			};
		}

        new GeckoDialogService().confirm(message, params).then(confirm => {
            if (confirm) {
                const attendance = this.attendanceExcludingStatus();
                let session_time_being_attended = this.state.times.find((time, key) => {
                    return time.id === (attendance || {}).event_id;
                });

                const eventId = session_time_being_attended.id || this.props.id;
                const attend = (going ? 'yes' : 'no');

                const executeFn = () => {
                	return this.executeUpdateAttendance(eventId, attend).then(() => {            
	                	new GeckoToastService().success(going ? __(STR_KEY.MODAL_SESSION_TOAST_UPDATED) : __(STR_KEY.MODAL_SESSION_TOAST_CANCELLED));
	                }).catch(err => {
	                	new GeckoToastService().error(err)
	                });
                }

	            return attend === 'yes' ? isSessionClosed(this.state.session, () => this.refreshPageAndModalData()).then(executeFn) : executeFn();
            }
        })
    }

	/**
	 *  😡
	 *
	 */
	attendanceExcludingStatus(ignore = [80, 90])
	{
		if (!this.props.id || !this.isBooked()) {
			return null;
		}

		const session_times = this.state.times.map((time, key) => {
			return time.id;
		});

		let attendance_for_session_time = getAttendances().find((attendance, key) => {
			return session_times.includes(attendance.event_id) && !ignore.includes(attendance.status);
		});

		return attendance_for_session_time;
	}

	getBookedTime()
	{	
		const attendance = this.attendanceExcludingStatus();

		if (attendance) {
			let session_time_being_attended = this.state.times.find((time, key) => {
				return time.id === attendance.event_id;
			});

			return session_time_being_attended;
		}

		return null;
	}

	getBookedTimeOrSessionTime()
	{	
		if (this.state.session) {
			let booked_time = this.getBookedTime();
			let start_time = null;
			let end_time = null;

			// Use the booked time
			if (booked_time) {
				start_time = moment.utc(booked_time.start_datetime);
				end_time = moment.utc(booked_time.end_datetime);
			} else {
				// If no session times are booked then use the event time
				const event = this.state.session;

				start_time = moment.utc(event.start_datetime);
				end_time = moment.utc(event.end_datetime);
			}

			return {
				start: start_time,
				end: end_time,
			}
		}

		return null;
	}

	isBooked(passed_event = null)
	{
		let event = null;

		if (!passed_event) {
			event = this.state.session;
		} else {
			event = passed_event;
		}

		if (!event) {
			return false;
		}

		if (!this.state.attendances[event.id]) {
			return false;
		}

		const state_attendance = this.state.attendances[event.id];

		if (state_attendance.status === 90 || state_attendance.status === 80) {
			return false;
		}

		return true;
	}

	executeUpdateAttendance(eventId, going = 'no') {
    	return new RsvpService().updateAttendance(eventId, going).then(() => this.refreshPageAndModalData());
    }

    executeUpdateCheckin(eventId) {
    	return new RsvpService().updateCheckin(eventId).then(() => this.refreshPageAndModalData());
    }

	refreshPageAndModalData() {
		return RefreshData().then(SelfCheckinRefreshInterval).then(() => this.refreshModalData());
	}

	composeAddAttendance(time)
	{		
		this.setState({disableTimeButtons: true, loading:true});
		return isSessionClosed(this.state.session, () => {
			this.refreshPageAndModalData();
			// Close confirmation / Reset times dropdown
			this.setState({
        		bookedSessionTimeId: this.getBookedTime().id,
        		selectedSessionTimeId: null
        	});
		}).then(() => {
			return this.executeUpdateAttendance(time.id, 'yes').then(() => {
        		new GeckoToastService().success(__(STR_KEY.MODAL_SESSION_TOAST_REGISTERED));
			}).catch(err => {
				new GeckoToastService().error(err);
			}).finally(() => {
        		this.setState({disableTimeButtons: false, loading:false});
        	});
		});
	}


    /* ==========================
    
        Renders

    ========================== */

    renderMetaFields()
    {
        if (this.state.session) {

            const times = this.getBookedTimeOrSessionTime();
            var timezone = this.state.topLevelEvent?.timezone ? this.state.topLevelEvent?.timezone : '';

            let dateStr;
			let timeStr;

			const startDate = DateUtils.dayMonthDateYear(times.start);
			const endDate = DateUtils.dayMonthDateYear(times.end);

			if (!DateUtils.isSameDay(times.start, times.end)) {
                dateStr = `${startDate} ${__(STR_KEY.MISC_TO)} ${endDate}`;
                timeStr = __(STR_KEY.MISC_VARIOUS_TIMES);
            } else {
                dateStr = startDate;
                timeStr = times.start.format(DateUtils.timeFormat) + ` ${__(STR_KEY.MISC_TO)} ` + times.end.format(DateUtils.timeFormat) + ', (' + timezone + ')';
            }

            const fields = [
                {
                    primary: dateStr,
                    secondary: timeStr,
                    icon: 'fal fa-calendar-alt',
                },
                {
                    primary: 'Spaces left',
                    secondary: 10,
                    icon: require('../../img/icon_spaces.svg'),
                    // hideWhen: () => !this.state.session.maximum, 
                    hideWhen: () => true,
                },
            ];

            const isOnline = RsvpService.isOnline(this.state.session);
            const [str, icon] = RsvpService.getPrettyDeliveryMethod(this.state.session, true);
            const video_uuid = (this.getBookedTime() || {}).video_uuid;
            var locationTitle = isOnline ? __(STR_KEY.MISC_ONLINE_EVENT) : getLocationTitle(this.state.location, this.state.topLevelEventLocation, (this.state.session.location_title_legacy || this.state.topLevelEvent.location_title_legacy));
            var locationAddress = isOnline ? null : getLocationAddress(this.state.location, this.state.topLevelEventLocation, (this.state.session.country  || this.state.topLevelEvent.country));
            var locationTruthy = this.state.location || this.state.topLevelEventLocation ? true : false;

            if (isOnline) {
            	fields.push({
                    primary: str,
                    secondary: null,
                    icon: icon,
                });

				const webinarUrl = this.state.session.webinar_url;
				const webinarDescription = this.state.session.webinar_description;

				// ONLY show when there is a webinar_url or webinar_description AND the attendance is ATTENDED or ENGAGED AND the session has not finished
            	if ((webinarUrl || webinarDescription) && this.attendanceExcludingStatus() && [RSVP_CONSTS.ATTENDANCE.STATUS_ATTENDED, RSVP_CONSTS.ATTENDANCE.STATUS_ENGAGED].indexOf(this.attendanceExcludingStatus().status) !== -1 && !RsvpService.hasEventPassed(this.getBookedTime())) {
					fields.push({
						primary: (<WebinarUrl url={webinarUrl} />),
						secondary: (<WebinarDescription description={webinarDescription} />),
						icon: 'fal fa-info-circle',
					});
				}

            } else {
                if (this.state.location || this.state.topLevelEventLocation) {
                	fields.push({
                        primary: locationTitle,
                        secondary: locationAddress,
                        icon: icon,
                        link: () => mapsSelector(this.state.location, this.state.topLevelEventLocation),
                        hideWhen: () => !this.state.location && !this.state.topLevelEventLocation
                    })
                } else if (this.state.session.location_title_legacy || this.state.topLevelEvent.location_title_legacy) {
                    fields.push({
                        primary: locationTitle,
                        secondary: locationAddress,
                        icon: icon,
                        hideWhen: () => locationTruthy
                    })
                }
            }

            return (
                <div className="section sessionMetaFields">
                    {
                        fields.map((field, key) => {

                            if (field.hideWhen && field.hideWhen()) {
                                return null;
                            }

                            return this.renderSessionMetaField(field, key)
                        })
                    }
                </div>
            );
        }

        return null;
    }

    renderSessionMetaField(field, key)
    {
        let style = '';
        let roleLink = '';
        if (field.link) {
            style = 'clickable';
            roleLink = 'link';
        }

        let ti = {tabIndex: 0};

        const handleOnKeyDown = (event) => {
            // 'Enter' keycode
            if (field.link && [13].includes(event.keyCode)){
                field.link();
            }
        }

        return (
            <div key={key} className="sessionMetaFieldContainer ">

                <div className="row justify-content-center">
                    <div className="col col-12">
                        <div className="sessionMetaIcon">
                            <i className={field.icon}/>
                        </div>
                        <div className="sessionMetaDetails" onClick={field.link} onKeyDown={handleOnKeyDown} role={`${roleLink}`} {...ti}>
                            <div style={{wordBreak: 'break-word'}} className={`sessionMetaField ${style}`}>
                                {field.primary} 
                            </div>

                            <div style={{wordBreak: 'break-word'}} className={`sessionMetaSubField ${style}`}>
                                {field.secondary}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

	renderCancelButton()
	{	
		const currentTime = Number(moment().format('X'));
        const endTime     = this.state.session ? this.state.session.end_datetime_utc : null;

		if (endTime && currentTime > endTime) return
        else if ([RSVP_CONSTS.ATTENDANCE.STATUS_INVITED, RSVP_CONSTS.ATTENDANCE.STATUS_ATTENDED, RSVP_CONSTS.ATTENDANCE.STATUS_ENGAGED, RSVP_CONSTS.ATTENDANCE.STATUS_DID_NOT_ATTEND].indexOf((this.attendanceExcludingStatus() || {}).status) !== -1) return
		else if (this.state.selectedSessionTimeId) return
		else if (this.state.session && this.isBooked()) {
			return (
				<div className="cancelBtn">
					<GeckoBtn
						className="btnCancel"
						id="cancel-session"
						name={__(STR_KEY.MODAL_SESSION_BTN_CANCEL)}
						icon="ban"
						handler={() => this.composeUpdateAttendance(false)}
					/>
				</div>
			);
		}

		return null;
	}

	renderManagementButtons()
	{
		if (!this.state.session || !this.isBooked() || !this.getBookedTime()) return null;

		// Dont show when session time is being changed
		if (this.state.selectedSessionTimeId) return null;

		const currentTime       = Number(moment().format('X'));
		const checkinIsEnabled  = this.state.session.checkin_start !== null;
        const checkinStartTime  = this.getBookedTime().start_datetime_utc - ((this.state.session.checkin_start || 0) * 60);
        const checkinHasStarted = currentTime >= checkinStartTime;
        const deliveryMethod    = this.state.session.delivery_method;

		const event = Object.assign({}, this.getBookedTime(), {
			delivery_method: deliveryMethod,
			checkin_start: this.state.session.checkin_start,
			checkin_started: checkinHasStarted,
			attendance: this.attendanceExcludingStatus()
		});

		const statusControl =  (<StatusControl event={event} checkinHandler={() => this.composeUpdateCheckin(true)} isSession={true} />);
		
		// attendance status is INVITED
		// AND
		// // self checkin is DISABLED
		// // OR
		// // self checkin is ENABLED AND checkin has NOT started

		const inviteControl = (!checkinIsEnabled || checkinIsEnabled && !(checkinHasStarted)) ? this.renderAcceptInvitationButton() : null;

		return (
			<div className="sessionManagement section">
	            {statusControl}
	            {inviteControl}
            </div>
        );
	}

	renderAcceptInvitationButton() {                
		const time                    = this.getBookedTime();
		const attendance              = this.state.attendances[time.id];
		const isInvited               = (attendance || {}).status === RSVP_CONSTS.ATTENDANCE.STATUS_INVITED;
		const isFull                  = time.full;
		const isFullAndHasWaitlisting = checkFullAndHasWaitlisting(time);
		const isClosed                = this.state.session.closed;

		if (isInvited) {
			if (!isFull || isFullAndHasWaitlisting) {

				let alertText = !isFull ? __(STR_KEY.CONTROLS_ALERT_INVITE) : __(STR_KEY.CONTROLS_ALERT_WAITLIST);
				let confirmBtn = !isFull ? __(STR_KEY.CONTROLS_BTN_INVITE_YES) : __(STR_KEY.CONTROLS_BTN_WAITLIST_YES);
				let declineBtn = __(STR_KEY.CONTROLS_BTN_INVITE_NO);
				let declineBtnId = !isFull ? 'session-decline-invitation' : 'session-decline-waitlist';
				let confirmBtnId = !isFull ? 'session-accept-invitation' : 'session-accept-waitlist';
				
				return (
					<div className="timeConfirmationBg flex-column">
						<div className="col-12 bodyText">
							{alertText}
						</div>

						<div className="timeConfirmationButtons">
							<div className="col cancelButton">
								<GeckoBtn 
                                    name={declineBtn} 
                                    id={declineBtnId}
                                    type={GECKO_CONSTS.BTN_TYPE_DEFAULT} 
                                    icon="fa-times" 
                                    handler={() => this.composeUpdateAttendance(false)} />
                           </div>
                           {!isClosed ? (
                           		<div className="col confirmButton">
	                           		<GeckoBtn 
		                                name={confirmBtn} 
		                                id={confirmBtnId}
		                                type={GECKO_CONSTS.BTN_TYPE_PRIMARY} 
		                                icon="fa-check" 
		                                handler={() => this.composeUpdateAttendance(true)} />
	                           </div>
                           	) : null}
                        </div>
					</div>
				);
			}
		}

		return null;
	}

	renderTimes()
	{	
		const session = this.state.session;
		const attendance = this.state.attendances[session.id];

		// Dont show when attendance status is ATTENDED or ENGAGED
		if (attendance && [RSVP_CONSTS.ATTENDANCE.STATUS_ATTENDED, RSVP_CONSTS.ATTENDANCE.STATUS_ENGAGED].indexOf(attendance.status) !== -1) return null;

		// If the user has booked something in this session then...
		let label = (this.isBooked() ? __(STR_KEY.MODAL_SESSION_TITLE_CHANGE) : __(STR_KEY.MODAL_SESSION_TITLE_REGISTER));

		if (this.state.times) {
			// Order by start date
			this.state.times = (this.state.times || []).sort((a,b) => (a.start_datetime > b.start_datetime) ? 1 : ((b.start_datetime > a.start_datetime) ? -1 : 0));
			
			const booked_time = this.getBookedTime();

			// Remove the fully booked and closed attendances
			const available_times = this.state.times.filter((time) => {
				const alreadyBooked           = booked_time && booked_time.id === time.id;
				const isFull                  = time.full;
				const isFullAndHasWaitlisting = checkFullAndHasWaitlisting(time);
				const isPast                  = RsvpService.hasEventPassed(time);

				// Alaways include time if it has already been booked
				if (alreadyBooked) return true;

				return (!isFull || isFullAndHasWaitlisting) && !isPast;
			});

			// If there are not times after filtering out the fully booked
			// ones then we can assume they are all booked
			if (available_times.length == 0) {
				return (<NoTimesAvailable />);
			}

			if (available_times.length > 1) {

				const sessionOptions = available_times.map(t => {
					const startTime = moment(t.start_datetime).format(DateUtils.timeFormat);
					const endTime = moment(t.end_datetime).format(DateUtils.timeFormat);
		
					let formattedTime;
					// If the session runs over multiple days show date & time
					if (moment(this.state.session.start_datetime).format('ddd D MMM') !== moment(this.state.session.end_datetime).format('ddd D MMM')) {
						formattedTime = `${moment(t.start_datetime).format('ddd D MMM')} ${startTime} - ${moment(t.end_datetime).format('ddd D MMM')} ${endTime}`;
					} else {
						formattedTime = `${startTime} - ${endTime}`;
					}

					return ({value: t.id, label: formattedTime})
				})

				const fields = [
					{
						key: 'bookedSessionTimeId',
						value: this.state,
						type: GECKO_CONSTS.FIELD_TYPE_SELECT,
						options: sessionOptions, 
						width: '100%',
						label: label,
						config: {
							clearable: false
						},
						disabled: session.closed					
					}
				];

				const handler = (key, value) => {
					this.setState({[key]: value}, () => {
						const selectedSessionTimeId = (this.getBookedTime() || {}).id === value ? null : value;
						this.setState({selectedSessionTimeId});				
					});
				};

				return (
					<div className="sessionTimes section">
						<div className="row d-flex flex-wrap ">
							<GeckoFields
								className="singleSessionDropdown"
								fields={fields}
								values={this.state}
								handler={handler}
							/>
							{this.state.selectedSessionTimeId ? this.renderTimeConfirmation() : null}
						</div>
					</div>
				);
			} else if (!this.isBooked() && available_times.length === 1) {
				
				const register = () => {
					this.setState({selectedSessionTimeId: available_times[0].id});
				}

				return (
					<div className="registerSection">
						{ this.state.selectedSessionTimeId ? this.renderTimeConfirmation() : 
							<GeckoBtn
								type={"primary"}
								name={__(STR_KEY.MODAL_SESSION_BTN_REGISTER)}
								id="session-register"
								icon="fa-user-check"
								handler={register}
								/> }
					</div>
				)
			}
		}

		return null;
	}

	renderWarning(selectedSession) {
		let clashingIDs = this.isSessionClashing(selectedSession);
		if (!clashingIDs) return null;
		else if (clashingIDs.length > 0) {
			let alertMessage = `${__(STR_KEY.MODAL_SESSION_ALERT_TIMES_CLASH)}`;


			return (
				<div className="row justify-content-center text-center">
					<div className="col-12 justify-content-center bodyText alert alert-warning">
						<div>
							<GeckoIcon icon="fa-exclamation-triangle" size="sm" />
							&nbsp;
							{alertMessage}
						</div>
						{this.renderClashingIds(clashingIDs)}
					</div>
				</div>
			)
		}
	}

	isSessionClashing(session) {
        var format = 'YYYY-MM-DDTHH:mm:ss.SSS';

        var beforeTime = moment(session.start_datetime, format);
        var afterTime = moment(session.end_datetime, format);

        let clashingIDs = [];

        // session time bookings
        let bookedSessionTimes = [];
        if(this.props.bookedSessions) {
            this.props.bookedSessions.forEach(session => {
                    if(session.time) {
                        bookedSessionTimes.push({id: session.id, timeId: session.time.id, title: session.title, start: moment(session.time.start_datetime), end: moment(session.time.end_datetime)});
                    }
            });
        }

        if(bookedSessionTimes){
            for (let subKey in bookedSessionTimes) {
                if (session.id !== parseInt(bookedSessionTimes[subKey].id)) {
                    let subSession = bookedSessionTimes[subKey];
                    let returnVal = `${subSession['title']} - ${moment(subSession['start']._i).format(`ll ${DateUtils.timeFormat}`)} - ${moment(subSession['end']._i).format(DateUtils.timeFormat)}`;

                    if (subSession['start'].isBetween(beforeTime, afterTime )) clashingIDs.push({id: subSession?.timeId, label:returnVal});
                    else if (subSession['end'].isBetween(beforeTime, afterTime )) clashingIDs.push({id: subSession?.timeId, label:returnVal});

                    else if (beforeTime.isBetween(subSession['start'], subSession['end'] )) clashingIDs.push({id: subSession?.timeId, label:returnVal});
                    else if (afterTime.isBetween(subSession['start'], subSession['end'] )) clashingIDs.push({id: subSession?.timeId, label:returnVal});

                    else if (subSession['start'].isSame(beforeTime)) clashingIDs.push({id: subSession?.timeId, label:returnVal});
                    else if (subSession['end'].isSame(afterTime)) clashingIDs.push({id: subSession?.timeId, label:returnVal});

                }
            }
        }
        return clashingIDs;
    }

	handleCancelClashingSession(session) {
		let message = __(STR_KEY.MODAL_CANCEL_CONTENT),
			params = {
				size: 'md',
				btns: {
					confirm: {label: __(STR_KEY.MODAL_CANCEL_BTN_YES), type: 'danger'},
					decline: {label: __(STR_KEY.MODAL_CANCEL_BTN_NO)}
				}
			};

        new GeckoDialogService().confirm(message, params).then(confirm => {
            if (confirm) {
				return this.executeUpdateAttendance(session?.id, 'no').then(() => {
					new GeckoToastService().success(__(STR_KEY.MODAL_SESSION_TOAST_CANCELLED));
				}).catch(err => {
					new GeckoToastService().error(err);
				});
			}
		});
	}

	renderClashingIds(clashingIDs) {
		return clashingIDs.map((session) => {
		  	return (
				<div className={`clashing-sessions-list-item d-flex align-items-center flex-row p-2`}>
					<div key={session} className='mr-auto align-middle'>{`• ${session?.label}`}</div>
					<div className='ml-2'>
						<button
							className='btn btn-sm pull-right'
							onClick={() => this.handleCancelClashingSession(session)}>
								<GeckoIcon icon="fa-trash-alt" size="sm" />
								&nbsp;
								{__(STR_KEY.MODAL_SESSION_BTN_REMOVE)}
						</button>
					</div>
				</div>
			)
		});
	}

	renderTimeConfirmation()
	{
		if (this.state.selectedSessionTimeId) {
			const newTime = this.state.times.find( ({ id }) => id === this.state.selectedSessionTimeId);

			const title = getSessionTimeTitle(newTime);
			// I have one question...
			let question = '',
				buttonText;

			if (checkFullAndHasWaitlisting(newTime)) {
				question = __(STR_KEY.MODAL_SESSION_ALERT_WAITLIST);
				buttonText = __(STR_KEY.CONTROLS_BTN_WAITLIST_YES);
			} else {
				question = (this.isBooked() ? __(STR_KEY.MODAL_SESSION_ALERT_CHANGE) : __(STR_KEY.MODAL_SESSION_ALERT_REGISTER));
				buttonText = this.isBooked() ? __(STR_KEY.MODAL_SESSION_BTN_CHANGE) : __(STR_KEY.MODAL_SESSION_BTN_YES)
			}

			const bookedSessionId = (this.getBookedTime() || {}).id;

			return (
				<div className="timeConfirmationBg flex-column">
					<div className="col-12 bodyText">
						{question} {title}?
					</div>
					{this.renderWarning(newTime)}

					<div className="timeConfirmationButtons">
							{ Boolean(eval(this.state?.topLevelEvent?.allow_clashing_sessions)) || this.isSessionClashing(newTime).length == 0 ?
								(
									<>
										<div className="col cancelButton">
											<GeckoBtn
												name={__(STR_KEY.MODAL_SESSION_BTN_NO)}
												id="no-session"
												icon="fa-times"
												type={"default"}
												handler={() => {
													this.setState({
														selectedSessionTimeId: null,
														bookedSessionTimeId: bookedSessionId
													});
												}}
											/>
										</div>
										<div className="col confirmButton">
											<GeckoBtn
												name={buttonText}
												id="yes-session"
												icon="fa-check"
												type={"primary"}
												handler={() => {
													return this.composeAddAttendance(newTime).then(() => {
														this.setState({selectedSessionTimeId: null});
													});
												}}
											/>
										</div>
									</>
								) : null
							}
						</div>
				</div>
			)
		};

		return null;
	}

    render() {
    	if (this.state.loading) {
    		return (
	    		<div className="singleSessionModal">
	    			<div className="sectionContainer">
	    				<Loader loading={this.state.loading} />
	    			</div>
	    		</div>
	    	);
    	}
    	
    	const session = this.state.session;
    	// Dont show controls when session is closed
    	const sessionClosedAndNotAlreadyAttending = session.closed && !this.getBookedTime();

		return (
            <div className="singleSessionModal">
            	<Header 
            		session={session} 
            		event={this.props.event} 
            		backButtonHandler={this.props.backButton} 
            		closeModalHandler={closeModal}
            	/>
				<div className="titleCardContainer section">
					<div className="row justify-content-center">
						<div className="col col-12">
							<TitleCard 
								session={session} 
								times={this.getBookedTimeOrSessionTime()} 
							/>
						</div>
					</div>
				</div>
			
            	<div className="sectionContainer">
	            	{this.renderMetaFields()}

	            	{sessionClosedAndNotAlreadyAttending ? (
	            		<SessionClosedAlert />
	            	) : (
	            		<>
	            		{this.renderTimes()}
	            		{this.renderManagementButtons()}
	            		{this.renderCancelButton()}
	            		</>
	            	)}

	            	<Description description={session.description} />
	            	<Tags tags={session.tags} />
	            	<HostsWrapper hosts={this.state.hosts} />
	            	<Location 
	            		session={session}
	            		sessionLocation={this.state.location} 
	            		eventLocation={this.state.topLevelEventLocation}
	            	/>
	            </div>

            </div>
        );
    }
}

SessionSingle.propTypes = {};

const mapStateToProps = (state) => {
    return {
       bookedSessions: state.sessions,
    }
}

export default connect(mapStateToProps)(SessionSingle);
